class LyckdWellnessCarousel extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.track = this.querySelector('[data-carousel-track]');
    this.previousButton = this.querySelector('[data-carousel-previous]');
    this.nextButton = this.querySelector('[data-carousel-next]');

    if (!this.track || !this.previousButton || !this.nextButton) return;

    const listenerOptions = { signal: this.abortController.signal };
    this.previousButton.addEventListener('click', () => this.scroll(-1), listenerOptions);
    this.nextButton.addEventListener('click', () => this.scroll(1), listenerOptions);
    this.track.addEventListener('scroll', () => this.updateControls(), { ...listenerOptions, passive: true });
    window.addEventListener('resize', () => this.updateControls(), { ...listenerOptions, passive: true });
    this.updateControls();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  scroll(direction) {
    const card = this.track.querySelector('.lyckd-system-card');
    if (!card) return;

    const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  }

  updateControls() {
    const end = this.track.scrollWidth - this.track.clientWidth;
    this.previousButton.disabled = this.track.scrollLeft <= 2;
    this.nextButton.disabled = this.track.scrollLeft >= end - 2;
  }
}

if (!customElements.get('lyckd-wellness-carousel')) {
  customElements.define('lyckd-wellness-carousel', LyckdWellnessCarousel);
}
